// Универсальный парсер числовых значений из строк.
// - Сохраняет значения null/undefined как есть
// - Возвращает число, если смог распарсить
// - Иначе возвращает исходное значение без изменений
export const toNumber = (value) => {
	if (value === null || value === undefined) return value
	if (typeof value === 'number') return value
	if (typeof value === 'string') {
		// Убираем пробелы-разделители, поддерживаем запятую как десятичный разделитель
		const normalized = value.replace(/\s+/g, '').replace(',', '.')
		const num = parseFloat(normalized)
		return Number.isNaN(num) ? value : num
	}
	return value
}
